import { TrendingUp } from "@mui/icons-material";
import { Box, Card, lighten, Typography, useTheme } from "@mui/material";

export function useColor(value) {
  const theme = useTheme();

  const resolveFromTheme = (path) =>
    path.split('.').reduce((obj, key) => obj?.[key], theme.palette);

  if (typeof value === 'string' && value.includes('.')) {
    const resolved = resolveFromTheme(value);
    if (resolved) return resolved;
  }

  return value;
}

export default function Kpi({ value, title, Icon, color }) {
  const theme = useTheme();
  if (!Icon) {
    Icon = TrendingUp;
  }
  color = useColor(color || theme.palette.primary.main);

  return <Card sx={{ p: 2, flex: 1, display: 'flex', flexDirection: 'row', gap: 2 }}>
    <Box sx={{ width: '60px', height: '60px', background: `linear-gradient(45deg, ${lighten(color, 0.8)} 0%, ${lighten(color, 0.9)} 100%)`, borderRadius: 1 }}>
      <Icon sx={{ color, width: '40px', height: '40px', m: '10px' }} />
    </Box>
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <Typography sx={{ fontWeight: 'bold', mb: 0, fontSize: 'h4.fontSize', lineHeight: 1 }}>{value || "KPI Value"}</Typography>
      <Typography variant="body2">{title || "KPI Title"}</Typography>
    </Box>
  </Card>;
}